<template>
  <b-card>
    <b-form>
      <b-row>
        <b-col cols="12">
          <div class="d-flex align-items-center mb-2">
            <feather-icon
              icon="LinkIcon"
              size="18"
            />
            <h4 class="mb-0 ml-75">
              Kết nối mạng xã hội
            </h4>
          </div>
          <p>Sau khi kết nối có thể đăng nhập hệ thống bằng mạng xã hội</p>

        </b-col>

        <!-- Profile Connections -->
        <b-col
          cols="12"
          class="mt-1"
        >

          <b-row class="text-center">
            <!-- facebook connect button -->
            <b-col
              md="6"
              cols="12"
              class="mb-1"
            >
              <b-card-text class="font-weight-bold mb-2 d-flex justify-content-center align-items-center">
                <font-awesome-icon
                  icon="fa-brands fa-facebook"
                  size="2x"
                  :style="{ color: '#0166e1', 'margin-right': '5px' }"
                /> Facebook
              </b-card-text>
              <div
                v-if="socialData.connections.facebook.connected"
                class="mb-1"
              >
                <b-avatar
                  size="40"
                  :src="socialData.connections.facebook.photoURL"
                />
              </div>
              <template v-if="socialData.connections.facebook.connected">
                <b-card-text class="mb-0">
                  {{ socialData.connections.facebook.displayName }}
                </b-card-text>
                <b-card-text class="mb-1">
                  @{{ socialData.connections.facebook.id }}
                </b-card-text>
                <b-link @click="disconnect('facebook')">
                  Ngắt kết nối
                </b-link>
              </template>
              <b-button
                v-else
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                @click="connect('facebook')"
              >
                Kết nối
              </b-button>
            </b-col>
            <!--/ facebook connect button -->

            <!-- google profile -->
            <b-col
              md="6"
              cols="12"
              class="mb-1"
            >
              <b-card-text class="font-weight-bold mb-2 d-flex justify-content-center align-items-center">
                <font-awesome-icon
                  icon="fa-brands fa-google"
                  size="2x"
                  :style="{ color: '#e63631', 'margin-right': '5px' }"
                /> Google
              </b-card-text>
              <div
                v-if="socialData.connections.google.connected"
                class="mb-1"
              >
                <b-avatar
                  size="40"
                  :src="socialData.connections.google.photoURL"
                />
              </div>
              <template v-if="socialData.connections.google.connected">
                <b-card-text class="mb-0">
                  {{ socialData.connections.google.displayName }}
                </b-card-text>
                <b-card-text class="mb-0">
                  @{{ socialData.connections.google.id }}
                </b-card-text>
                <b-link @click="disconnect('google')">
                  Ngắt kết nối
                </b-link>
              </template>
              <b-button
                v-else
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                @click="connect('google')"
              >
                Kết nối
              </b-button>
            </b-col>
            <!--/ google profile -->
          </b-row>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BCard, BCardText, BLink, BAvatar,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import {
  signInWithPopup, FacebookAuthProvider, GoogleAuthProvider, signOut,
} from 'firebase/auth';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faFacebook, faGoogle } from '@fortawesome/free-brands-svg-icons';
import firebaseAuth from '@/libs/firebaseConfig'

library.add(faFacebook, faGoogle);

export default {
  components: {
    BButton,
    BForm,
    BRow,
    BCol,
    BCard,
    BCardText,
    BLink,
    BAvatar,
    FontAwesomeIcon,
  },
  directives: {
    Ripple,
  },
  props: ['userData'],
  data() {
    return {
      socialData: {
        connections: {
          google: {
            photoURL: require('@/assets/images/avatars/default_avatar.jpg'),
            id: 'luraweber',
            connected: 0,
            user: null,
          },
          facebook: {
            photoURL: require('@/assets/images/avatars/default_avatar.jpg'),
            id: 'luraweber',
            connected: 0,
            user: null,
          },
        },
      },
    }
  },
  computed: {

  },
  watch: {
    // userData(newValue, oldValue) {
    //   if (newValue !== oldValue) {
    //     const fbUser = this.userData.fb_user ? JSON.parse(this.userData.fb_user) : null;
    //     const ggUser = this.userData.gg_user ? JSON.parse(this.userData.gg_user) : null;
    //     console.log('userData--->', this.userData);
    //     console.log('fbUser', fbUser);
    //     if (fbUser) {
    //       this.socialData.connections.facebook.avatar = fbUser.avatar
    //       this.socialData.connections.facebook.id = fbUser.uid
    //       this.socialData.connections.facebook.photoURL = fbUser.photoURL
    //       this.socialData.connections.facebook.connected = this.userData.fb_connected
    //       this.socialData.connections.facebook.user = fbUser
    //       this.socialData.connections.facebook.displayName = fbUser.displayName
    //     }
    //     if (ggUser) {
    //       this.socialData.connections.google.avatar = ggUser.avatar
    //       this.socialData.connections.google.id = ggUser.uid
    //       this.socialData.connections.google.photoURL = ggUser.photoURL
    //       this.socialData.connections.google.connected = this.userData.gg_connected
    //       this.socialData.connections.google.user = ggUser
    //       this.socialData.connections.google.displayName = ggUser.displayName
    //     }
    //   }
    // },
  },
  mounted() {
    const fbUser = this.userData.fb_user ? JSON.parse(this.userData.fb_user) : null;
    const ggUser = this.userData.gg_user ? JSON.parse(this.userData.gg_user) : null;
    // console.log('userData--->', this.userData);
    // console.log('fbUser', fbUser);
    if (fbUser) {
      this.socialData.connections.facebook.avatar = fbUser.avatar
      this.socialData.connections.facebook.id = fbUser.uid
      this.socialData.connections.facebook.photoURL = fbUser.photoURL
      this.socialData.connections.facebook.connected = this.userData.fb_connected
      this.socialData.connections.facebook.user = fbUser
      this.socialData.connections.facebook.displayName = fbUser.displayName
    }
    if (ggUser) {
      this.socialData.connections.google.avatar = ggUser.avatar
      this.socialData.connections.google.id = ggUser.uid
      this.socialData.connections.google.photoURL = ggUser.photoURL
      this.socialData.connections.google.connected = this.userData.gg_connected
      this.socialData.connections.google.user = ggUser
      this.socialData.connections.google.displayName = ggUser.displayName
    }
  },
  methods: {
    updateAccount(data) {
      this.$store.dispatch('account/updateAccount', data)
        .then((res) => {
          // console.log('res', res);
          if (res.status === 200) {
            if (data.provider === 'facebook') {
              this.socialData.connections.facebook.connected = data.type === 'connect' ? 1 : 0
              this.socialData.connections.facebook.photoURL = data.fb_user.photoURL
              this.socialData.connections.facebook.id = data.fb_user.uid
              this.socialData.connections.facebook.displayName = data.fb_user.displayName
            } else {
              this.socialData.connections.google.connected = data.type === 'connect' ? 1 : 0
              this.socialData.connections.google.photoURL = data.gg_user.photoURL
              this.socialData.connections.google.id = data.gg_user.uid
              this.socialData.connections.google.displayName = data.gg_user.displayName
            }
          }
        })
    },

    connect(type) {
      const that = this;
      const authProvider = type === 'facebook' ? new FacebookAuthProvider() : new GoogleAuthProvider();
      if (type === 'facebook') {
        authProvider.addScope('public_profile');
        authProvider.addScope('email');
      }
      authProvider.setCustomParameters({
        display: 'popup',
      });
      signInWithPopup(firebaseAuth, authProvider)
        .then((result) => {
          // console.log('result', result);
          // The signed-in user info.
          const { user } = result;

          // // This gives you a Facebook Access Token. You can use it to access the Facebook API.
          const credential = FacebookAuthProvider.credentialFromResult(result);
          const { accessToken } = credential;

          // console.log('credential', credential);
          let updateData = {
            type: 'connect',
            update_type: 'social',
            provider: 'facebook',
            fb_id: user.uid,
            fb_user: user.providerData[0],
          }
          if (type === 'google') {
            updateData = {
              type: 'connect',
              update_type: 'social',
              provider: 'google',
              gg_id: user.uid,
              gg_user: user.providerData[0],
            }
          }
          that.updateAccount(updateData)
        })
        .catch((error) => {
          // Handle Errors here.
          const errorCode = error.code;
          const errorMessage = error.message;
          // The email of the user's account used.
          const { email } = error.customData;
          // The AuthCredential type that was used.
          let credential = FacebookAuthProvider.credentialFromError(error);
          if (type === 'google') {
            credential = GoogleAuthProvider.credentialFromError(error);
          }

          // console.log('error', errorCode, errorMessage, email, credential);
        });
    },
    disconnect(type) {
      signOut(firebaseAuth).then(() => {
        // Sign-out successful.
        let updateData = {
          type: 'disconnect',
          update_type: 'social',
          provider: 'facebook',
          fb_id: this.socialData.connections.facebook.id,
          fb_user: this.socialData.connections.facebook.user,
        }
        if (type === 'google') {
          updateData = {
            type: 'disconnect',
            update_type: 'social',
            provider: 'google',
            gg_id: this.socialData.connections.google.id,
            gg_user: this.socialData.connections.google.user,
          }
        }
        this.updateAccount(updateData)
      }).catch((error) => {
        // console.log(error);
        // An error happened.
      });
    },

  },
}
</script>
